/**
 * FinalCTA component - Bottom CTA section with download and dashboard links
 */

import {Link} from 'react-router-dom';
import {Container} from '../ui/Container';
import {Section} from '../ui/Section';
import {Button} from '../ui/Button';
import {ROUTES} from '../../config/constants';
import {useScrollAnimation} from '../../hooks/useScrollAnimation';

export function FinalCTA() {
  const {ref, isVisible} = useScrollAnimation();
  // TODO: Replace with actual Windows download URL when available
  const windowsDownloadUrl = 'https://github.com/yourusername/voxapilot/releases/latest/download/VoxaPilot-Setup.exe';

  const handleDownload = () => {
    // Open download link in new tab
    window.open(windowsDownloadUrl, '_blank');
  };

  return (
    <Section padding="xl" background="white" ref={ref} className="bg-background dark:bg-[#1E1E1E]">
      <Container>
        <div className={`max-w-3xl mx-auto text-center space-y-10 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {/* Heading */}
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-textPrimary dark:text-[#CCCCCC]">
              Try VoxaPilot now
            </h2>
            <p className="text-lg sm:text-xl text-textSecondary dark:text-[#858585] max-w-2xl mx-auto leading-relaxed">
              Get started in minutes. Download the desktop app or access the web dashboard.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-5 justify-center items-center pt-2">
            <Button
              variant="primary"
              size="lg"
              onClick={handleDownload}
              className="w-full sm:w-auto min-w-[200px] bg-[#1E1E1E] dark:bg-[#1E1E1E] text-white hover:bg-[#2D2D30] dark:hover:bg-[#2D2D30] focus:ring-[#1E1E1E] dark:focus:ring-[#1E1E1E] hover:shadow-lg hover:shadow-[#1E1E1E]/25 dark:hover:shadow-[#1E1E1E]/25"
            >
              <svg
                className="w-5 h-5 mr-2 inline-block"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              Download for Windows
            </Button>

            <Link to={ROUTES.SIGN_IN}>
              <Button
                variant="outline"
                size="lg"
                className="w-full sm:w-auto min-w-[200px]"
              >
                <svg
                  className="w-5 h-5 mr-2 inline-block"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Go To Dashboard
              </Button>
            </Link>
          </div>

          {/* Additional Info */}
          <div className="pt-6">
            <p className="text-base text-textTertiary dark:text-[#6A6A6A]">
              Available for Windows • macOS and Linux coming soon
            </p>
          </div>
        </div>
      </Container>
    </Section>
  );
}

